import { IconBrandGoogle, IconBuilding, IconDeviceDesktop, IconUsers } from '@tabler/icons-react'
import type { NavigationItem } from '../interfaces'

/** Way into the Classroom supervision view (AR-670): the manager profile
 *  never goes through the teacher settings hub. Managers do NOT connect an
 *  account — they track the school's linked courses and the Google account
 *  behind each link. Appended only when the school has the
 *  arc-google-classroom flag. */
export const CLASSROOM_NAVIGATION_ITEM: NavigationItem = {
  key: 'google-classroom',
  titleKey: 'classroom.gcwSettingsTitle',
  descriptionKey: 'classroom.gcwManagerNavDescription',
  to: '/teacher/google-classroom',
  icon: IconBrandGoogle,
  color: 'blue',
}

/** The management shortcuts shown as vertical cards with a tinted icon. */
export const NAVIGATION_ITEMS: NavigationItem[] = [
  {
    key: 'school-details',
    titleKey: 'manager_dashboard.nav_school_details_title',
    descriptionKey: 'manager_dashboard.nav_school_details_desc',
    to: '/teacher/school-details',
    icon: IconBuilding,
    color: 'green',
  },
  {
    key: 'manage-faculty',
    titleKey: 'manager_dashboard.nav_faculty_title',
    descriptionKey: 'manager_dashboard.nav_faculty_desc',
    to: '/teacher/manage-faculty',
    icon: IconDeviceDesktop,
    color: 'indigo',
  },
  {
    key: 'manage-students',
    titleKey: 'manager_dashboard.nav_students_title',
    descriptionKey: 'manager_dashboard.nav_students_desc',
    to: '/teacher/manage-students',
    icon: IconUsers,
    color: 'teal',
  },
]
